interface ApiErrorPayload {
    message?: string;
    error?: string;
    statusCode?: number;
  }
  
 export const parseApiErrorUtil = (error: Error | null): ApiErrorPayload => {
    if (!error?.message) return {};
  
    try {
      const parsed = JSON.parse(error.message);
      return typeof parsed === 'object' ? parsed : {};
    } catch {
      return {};
    }
  }
